import script from "./SectionNewsCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionNewsCarousel.vue?vue&type=script&setup=true&lang=js"

import "./SectionNewsCarousel.vue?vue&type=style&index=0&id=7ed669d6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ed669d6"]])

export default __exports__